<template>
    <div>
        <div class="cd-timeline-content mr-3">
            <div>
                <div class="cd-timeline-content-text">
                    <div v-html="oneLog.text" />
                    <div class="grey mt-1 fs-2">
                        {{ $filters.dateFormatter(oneLog.timestamp, 'NORMAL_DATE_TIME', true) }}
                    </div>
                </div>
                <div
                    v-if="
                        oneLog.more &&
                        Object.values(oneLog.more).length > 0 &&
                        oneLog.more.logs &&
                        Object.values(oneLog.more.logs).length > 0
                    "
                    class="cd-timeline-content-detail"
                >
                    <ul :class="'detail-' + oneLog.icon">
                        <li v-for="(log, index) in oneLog.more.logs" :key="index">
                            <p class="info-label">{{ log.label }}</p>
                            <p class="info-value">{{ log.value }}</p>
                        </li>
                    </ul>
                </div>
                <div v-if="oneLog.linked.length > 0" class="cd-timeline-links">
                    <p>{{ $l10n.__('Associé à') }}</p>
                    <ul>
                        <li v-for="(link, key) in oneLog.linked" :key="key">
                            <i :class="getIconByType(oneLog.objecttype)"></i>
                            <span v-html="link.html"></span>
                        </li>
                    </ul>
                </div>
                <ul
                    v-if="oneLog.more && Object.values(oneLog.more).length > 0 && displayHistory"
                    class="cd-timeline-content-mail-timeline"
                >
                    <li v-for="(log, index) in oneLog.more.history" :key="index">
                        <p>
                            <span class="chip chip-default"></span>
                            <span>{{ log.event }}</span>
                            <span v-html="log.more" />
                            {{ $filters.dateFormatter(log.timestamp, 'NORMAL_DATE_TIME', true) }}
                        </p>
                    </li>
                </ul>
            </div>
            <a
                v-if="oneLog.more && oneLog.more.history"
                data-toggle="collapse"
                :data-toggle-text="$t.__('timeline.TimelinePrimaryCard.hide_history')"
                class="toggle-historic"
                :href="'#' + oneLog.uniqid"
                >{{ $l10n.__("Voir l'historique") }}</a
            >
        </div>
    </div>
</template>

<script>
import IconMixin from '../../mixins/IconMixin';
export default {
    mixins: [IconMixin],
    props: ['oneLog'],

    data() {
        return {
            displayHistory: true,
        };
    },

    methods: {
        toggleHistory() {
            this.displayHistory = !this.displayHistory;
        },
    },
};
</script>
